import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "~/assets/img/newLanding/logo.png";
import { HamburgerMenuIcon } from "~/assets/svg/LandingIcon";
import OutsideAlerter from "~/common/hooks/OutsideAlerter";
import { useSetAtom } from "jotai";
import { promotionModalAtom } from "~/atoms/Landing";
// import TransLanguageSelect from "~/common/components/TransLanguageSelect";
import { useTranslation } from "react-i18next";

const LandingHeader = () => {
	const { t } = useTranslation();
	const location = useLocation();
	const current = location.pathname;
	const navigate = useNavigate();

	const [loginToggle, setLoginToggle] = useState("none");
	const clickHandler = () => setLoginToggle("none");

	const [sideBarMenu, setSideBarMenu] = useState(false);
	const sideBarToggle = () => {
		setSideBarMenu(!sideBarMenu);
	};
	const clickOutHandler = () => setSideBarMenu(false);
	const setPromotionModal = useSetAtom(promotionModalAtom);

	return (
		<>
			<header className="landing-header">
				<div className="wrap">
					<h1 className="logo-wrap" onClick={() => navigate("/")}>
						<div className="img-wrap">
							<img src={logo} alt={t("Landing.LandingHeader.alt")} />
						</div>
					</h1>
					<ul className="nav">
						<li
							className={`nav-item ${current === "/" ? "selected" : ""}`}
							onClick={() => navigate("/")}
						>
							{t("Landing.LandingHeader.nav.1")}
						</li>
						<li className="nav-item">
							<a href={"https://docs.gitbal.io"} target="_blank">
								{t("Landing.LandingHeader.nav.2")}
							</a>
						</li>
						<li className="nav-item">
							<a
								href={"https://map.gitbal.io/"}
								target="_blank"
								rel="noopener noreferrer"
							>
								{t("Landing.LandingHeader.nav.3")}
							</a>
						</li>
						<li
							className={`nav-item ${current === "/case" ? "selected" : ""}`}
							onClick={() => {
								navigate("/case");
							}}
						>
							{t("Landing.LandingHeader.nav.4")}
						</li>
						<li
							className={`nav-item ${current === "/price" ? "selected" : ""}`}
							onClick={() => {
								navigate("/price");
							}}
						>
							가격정책
						</li>
					</ul>
					<OutsideAlerter callback={clickHandler}>
						<div className="right-wrap">
							{/*<TransLanguageSelect />*/}
							<div className="login-wrap">
								<div
									className={`btn__outline btn-login angled ${
										loginToggle === "" ? "active" : ""
									}`}
									color="landing"
									onClick={() => {
										if (loginToggle === "none") {
											setLoginToggle("");
										} else {
											setLoginToggle("none");
										}
									}}
								>
									{t("Landing.LandingHeader.login-wrap.login")}
									<div className="nav-dropdown" style={{ display: loginToggle }}>
										<button
											type="button"
											className="dropdown-link"
											onClick={() => navigate("/login")}
										>
											{t("Landing.LandingHeader.login-wrap.st")}
										</button>
										<button
											type="button"
											className="dropdown-link"
											onClick={() => window.open("http://vc.gitbal.io")}
										>
											{t("Landing.LandingHeader.login-wrap.vc")}
										</button>
									</div>
								</div>
								{/*<button*/}
								{/*	type="button"*/}
								{/*	className="btn__solid btn-start"*/}
								{/*	// onClick={() => navigate("/login")}*/}
								{/*	onClick={() => setPromotionModal(true)}*/}
								{/*>*/}
								{/*	{t("Landing.LandingHeader.btn-start")}*/}
								{/*</button>*/}

								{/*햄버거 메뉴*/}
								<button type="button" className="btn-menu" onClick={sideBarToggle}>
									<span className="menu-text">Menu</span>
									<HamburgerMenuIcon />
								</button>
							</div>
						</div>
					</OutsideAlerter>
				</div>
			</header>
			<OutsideAlerter callback={clickOutHandler}>
				<div className={`landing-sidebar ${sideBarMenu ? "active" : "inactive"}`}>
					<button type="button" className="btn-menu" onClick={sideBarToggle}>
						<HamburgerMenuIcon />
					</button>
					<ul className="nav">
						<li
							className={`nav-item ${current === "/" ? "selected" : ""}`}
							onClick={() => navigate("/")}
						>
							{t("Landing.LandingHeader.landing-sidebar.nav.1")}
						</li>
						<li>
							<a href={"https://docs.gitbal.io"} target="_blank" className="nav-item">
								{t("Landing.LandingHeader.landing-sidebar.nav.2")}
							</a>
						</li>
						<li className="nav-item">
							{t("Landing.LandingHeader.landing-sidebar.nav.3")}
						</li>
						<li
							className={`nav-item ${current === "/case" ? "selected" : ""}`}
							onClick={() => {
								navigate("/case");
							}}
						>
							{t("Landing.LandingHeader.landing-sidebar.nav.4")}
						</li>
						<li className="nav-item disabled">
							{t("Landing.LandingHeader.landing-sidebar.nav.5")}
						</li>
					</ul>
					<div className="site-group">
						<button
							type="button"
							className="btn__solid btn-site angled"
							onClick={() => navigate("/login")}
						>
							{t("Landing.LandingHeader.landing-sidebar.st-login")}
						</button>
						<button
							type="button"
							className="btn__solid btn-site angled"
							onClick={() => window.open("http://vc.gitbal.io")}
						>
							{t("Landing.LandingHeader.landing-sidebar.vc-login")}
						</button>
					</div>
				</div>
			</OutsideAlerter>
		</>
	);
};

export default LandingHeader;
